import supabase from '../supabase/supabase';

const BUCKET = 'listing-images';

const extensionForType = (type = '') => {
  if (type.includes('png')) return 'png';
  if (type.includes('webp')) return 'webp';
  if (type.includes('avif')) return 'avif';
  return 'jpg';
};

const dataUrlToBlob = async (dataUrl) => {
  const response = await fetch(dataUrl);
  return response.blob();
};

const publicPathFromUrl = (url) => {
  if (!url || typeof url !== 'string') return null;
  const marker = `/storage/v1/object/public/${BUCKET}/`;
  const index = url.indexOf(marker);
  return index === -1 ? null : decodeURIComponent(url.slice(index + marker.length));
};

export const storageService = {
  isInlineImage(value) {
    return typeof value === 'string' && value.startsWith('data:image/');
  },

  async uploadDataUrl(dataUrl, { userId, folder = 'listings' } = {}) {
    if (!this.isInlineImage(dataUrl) || !userId) return dataUrl;

    const blob = await dataUrlToBlob(dataUrl);
    const extension = extensionForType(blob.type);
    const id = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    const path = `${userId}/${folder}/${id}.${extension}`;

    const { error } = await supabase.storage.from(BUCKET).upload(path, blob, {
      cacheControl: '31536000',
      contentType: blob.type || 'image/jpeg',
      upsert: false,
    });

    if (error) throw error;

    const { data } = supabase.storage.from(BUCKET).getPublicUrl(path);
    return data.publicUrl;
  },

  async removePublicUrl(url) {
    const path = publicPathFromUrl(url);
    if (!path) return;
    const { error } = await supabase.storage.from(BUCKET).remove([path]);
    if (error) throw error;
  },
};
